// @flow
import cn from 'classnames';
import {ReactComponent as CrossIcon} from 'modules/common/icons/cross.svg';
import React from 'react';
import styles from './styles.local.less';

type TTransitionState = 'entering' | 'entered' | 'exiting' | 'exited';

type TProps = {
    appearance: string,
    children: React$Node,
    onDismiss: (any) => void,
    transitionDuration: number,
    transitionState: TTransitionState,
};

/** Классы для разных вариантов уведомления */
const appearanceClassData = {
    error: styles.error,
    success: styles.success,
};

/** Стили для различных состояний для анимаций */
const toastStateData = {
    entered: {opacity: 1, transform: 'scale(1)'},
    entering: {opacity: 0, transform: 'scale(0)'},
    exited: {opacity: 0, transform: 'scale(0.66)'},
    exiting: {opacity: 0, transform: 'scale(0.66)'},
};

/**
 * Уведомление
 * @param props Свойства
 * @returns React-компонент
 */
export const NotificationToast = ({appearance, children, onDismiss, transitionState, transitionDuration}: TProps) => {
    return (
        <div
            className={cn(styles.notification, appearanceClassData[appearance])}
            style={{
                ...toastStateData[transitionState],
                transition: `transform ${transitionDuration}ms cubic-bezier(0.2, 0, 0, 1), opacity ${transitionDuration}ms, box-shadow ${transitionDuration}ms`,
            }}
        >
            {children}
            <button className={cn(styles.button, 'icon')} onClick={onDismiss} type="button">
                <CrossIcon />
            </button>
        </div>
    );
};
